//@flow
import React, { Component } from 'react';
import { CalendarFilterDiv, CalendarSvg, CalendarP } from './CalendarStyles';
import DisplayCalendar from './DisplayCalendar';
import CalendarClosed from './CalendarClosed';

type Props = {
  calendarFilterState: boolean,
  toggleCalendarFilter: () => void,
  calendarStart?: string,
  calendarEnd?: string,
  clearCalendarFilter: () => void,
  expandWholeRow?: boolean,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  windowSize: string,
  className?: string,
  setCalendarSaga: () => void,
  rightEnd?: boolean,
  disabled?: boolean
  // setCalendarSaga: () => void
};

class CalendarFilter extends Component<Props> {
  handleCalendar = () => {
    if (this.props.disabled) {
      return;
    }
    if (
      !this.props.calendarStart ||
      !this.props.calendarEnd ||
      !this.props.disabled
    ) {
      this.props.toggleCalendarFilter();
    }
  };

  render() {
    return (
      <CalendarFilterDiv
        className={this.props.className}
        isActive={this.props.calendarStart && this.props.calendarEnd}
        onClick={this.handleCalendar}
        expandWholeRow={this.props.expandWholeRow}
        rightEnd={this.props.rightEnd}
        disabled={this.props.disabled}
      >
        <CalendarSvg
          isActive={this.props.calendarStart && this.props.calendarEnd}
          disabled={this.props.disabled}
        />

        {this.props.calendarStart && this.props.calendarEnd ? (
          <CalendarClosed
            calendarStart={this.props.calendarStart}
            calendarEnd={this.props.calendarEnd}
            clearCalendarFilter={this.props.clearCalendarFilter}
            disabled={this.props.disabled}
          />
        ) : (
          <>
            {/* <CalendarSvg disabled={this.props.disabled} /> */}
            <CalendarP disabled={this.props.disabled}> Date Filter</CalendarP>
          </>
        )}
        <DisplayCalendar
          calendarStart={this.props.calendarStart}
          calendarEnd={this.props.calendarEnd}
          setCalendarStartFilter={this.props.setCalendarStartFilter}
          setCalendarEndFilter={this.props.setCalendarEndFilter}
          toggleCalendarFilter={this.props.toggleCalendarFilter}
          calendarFilterState={this.props.calendarFilterState}
          windowSize={this.props.windowSize}
          setCalendarSaga={this.props.setCalendarSaga}
          disabled={this.props.disabled}
        />
      </CalendarFilterDiv>
    );
  }
}

export default CalendarFilter;
